import { makeStyles } from '@mui/styles';

/**
 * Applies font-family KaiTi (registered in global.css via @font-face + bundled .ttf).
 */
export function useKaiTiFontStyles(color: string | null = null, fontSize: string | null = null) {
  return makeStyles(() => ({
    customFont: {
      fontFamily: 'KaiTi, Roboto, Helvetica, Arial, sans-serif',
      ...(color !== null && { color }),
      ...(fontSize !== null && { fontSize }),
    },
  }))();
}
